import { Api } from "@/api";
import { UserLoginType } from "@/DTO";

export const EditPublisher = (user: UserLoginType, id: string, name: string ) => {
  return new Promise<{
    data: any
  }>((resolve, reject) => {
    const api = new Api({
      method: "patch",
      path: `publisher/${id}`,
      body: JSON.stringify(
        {
          name: name,
        }
      ),
      header: {
        Authorization: "Bearer " + user.accessToken,
        "Content-Type": "application/json"
      }
    });
    return api
      .call()
      .then((data: any) => {
        return resolve({
          data: data.data
        });
      })
      .catch((err: any) => {
        return reject(err);
      });
  });
};

export const RemovePublisher = (user: UserLoginType, id: string) => {
  return new Promise<{
    data: any
  }>((resolve, reject) => {
    const api = new Api({
      method: "delete",
      path: `publisher/${id}`,
      header: {
        Authorization: "Bearer " + user.accessToken,
        "Content-Type": "application/json"
      }
    });
    return api
      .call()
      .then((data: any) => {
        return resolve({
          data: data.data
        });
      })
      .catch((err: any) => {
        return reject(err);
      });
  });
};


